import { CountryISOCodeEnum } from './interface';
export const ACCESS_TOKEN_HEADER = 'x-access-token';
export const PHONE_NUMBER_MASKS = {
    [CountryISOCodeEnum.Argentina]: '(..) ........',
    [CountryISOCodeEnum.Australia]: '(..) .... ....',
    [CountryISOCodeEnum.Belgium]: '... .. .. ..',
    [CountryISOCodeEnum.Brazil]: '(..) .........',
    [CountryISOCodeEnum.Belarus]: '(..) ... .. ..',
    [CountryISOCodeEnum.Canada]: '(...) ...-....',
    [CountryISOCodeEnum.Switzerland]: '.. ... .. ..',
    [CountryISOCodeEnum.Cote_dIvoire]: '.. .. .. ..',
    [CountryISOCodeEnum.China]: '..-.........',
    [CountryISOCodeEnum.Costa_Rica]: '....-....',
    [CountryISOCodeEnum.Cyprus]: '.. ......',
    [CountryISOCodeEnum.Germany]: '.... ........',
    [CountryISOCodeEnum.Denmark]: '.. .. .. ..',
    [CountryISOCodeEnum.Estonia]: '.... ......',
    [CountryISOCodeEnum.Spain]: '... ... ...',
    [CountryISOCodeEnum.Finland]: '.. ... .. ..',
    [CountryISOCodeEnum.France]: '. .. .. .. ..',
    [CountryISOCodeEnum.United_Kingdom]: '.... ......',
    [CountryISOCodeEnum.Guatemala]: '....-....',
    [CountryISOCodeEnum.Hong_Kong]: '.... ....',
    [CountryISOCodeEnum.Haiti]: '....-....',
    [CountryISOCodeEnum.Ireland]: '.. .......',
    [CountryISOCodeEnum.Israel]: '... ... ....',
    [CountryISOCodeEnum.India]: '.....-.....',
    [CountryISOCodeEnum.Iceland]: '... ....',
    [CountryISOCodeEnum.Italy]: '... .......',
    [CountryISOCodeEnum.Japan]: '.. .... ....',
    [CountryISOCodeEnum.South_Korea]: '... .... ....',
    [CountryISOCodeEnum.Kazakhstan]: '... ...-..-..',
    [CountryISOCodeEnum.Moldova]: '(..) ..-..-..',
    [CountryISOCodeEnum.Mexico]: '... ... ....',
    [CountryISOCodeEnum.Malaysia]: '..-....-....',
    [CountryISOCodeEnum.Netherlands]: '.. ........',
    [CountryISOCodeEnum.Norway]: '... .. ...',
    [CountryISOCodeEnum.New_Zealand]: '...-...-....',
    [CountryISOCodeEnum.Philippines]: '.... .......',
    [CountryISOCodeEnum.Pakistan]: '...-.......',
    [CountryISOCodeEnum.Poland]: '...-...-...',
    [CountryISOCodeEnum.Russia]: '(...) ...-..-..',
    [CountryISOCodeEnum.Sweden]: '(...) ...-...',
    [CountryISOCodeEnum.Singapore]: '....-....',
    [CountryISOCodeEnum.El_Salvador]: '....-....',
    [CountryISOCodeEnum.Turkey]: '... ... .. ..',
    [CountryISOCodeEnum.Ukraine]: '(..) ... .. ..',
    [CountryISOCodeEnum.United_States]: '(...) ...-....',
    [CountryISOCodeEnum.Vatican_City]: '.. .... ....',
};
//# sourceMappingURL=constants.js.map